import React from "react";
import { Box, Typography, Divider, Icon, makeStyles } from "@material-ui/core";
import * as styles from "../../theme/commonStyles";

import Project from "./../Project";
import toDoListScreenshot from "./../../images/ToDoListScreenshot.jpg";
import portfolioWebsiteScreenshot from "./../../images/PortfolioWebsiteScreenshot.JPG";
import CMIC from "./../../images/CMIC.JPG";
import sdfp from "./../../images/sd-fp.png";
import qhfp from "./../../images/qh-fp.png";
import mlfp from "./../../images/ml-fp.png";
import kvk from "./../../images/kvk-fp.png";
import smoney from "./../../images/smart-money-ss.png";
import hayag from "./../../images/hayagreeva-ss.png";
import strades from "./../../images/strades.png";


import cssArtScreenshot from "./../../images/cssart.jpg";

const ProjectsPage = () => {
  const useStyles = makeStyles({
    columnDiv: {
      ...styles.columnDiv,
    },
    mainDiv: {
      width: "auto",
    },
    headerText: {
      ...styles.headerText,
    },
    projectText: {
      marginTop: "5rem",
    },
    divider: {
      ...styles.divider,
    },
    projectsDivider: {
      paddingBottom: "0.15rem",
    },
    icons: {
      fontSize: "1.5rem",
      display: "flex",
      width: "100%",
      margin: "0.5rem 0",
    },
  });
  const classes = useStyles();

  const tailwindcssIcon = (
    <Icon
      className="devicon-tailwindcss-original"
      fontSize="inherit"
      style={{ marginRight: "0.35rem" }}
    />
  );

  const nextjsIcon = (
    <Icon
      className="devicon-nextjs-plain colored"
      fontSize="inherit"
      style={{ marginRight: "0.35rem" }}
    />
  );

  const expressJsIcon = (
    <Icon
      className="devicon-express-original colored"
      fontSize="inherit"
      style={{ marginRight: "0.35rem" }}
    />
  );

  const mongoIcon = (
    <Icon
      className="devicon-mongodb-plain"
      fontSize="inherit"
      style={{ marginRight: "0.35rem" }}
    />
  );

  const reactIcon = (
    <Icon
      className="devicon-react-original"
      fontSize="inherit"
      style={{ marginRight: "0.35rem" }}
    />
  );

  const bootStrapIcon = (
    <Icon
      className="devicon-bootstrap-plain"
      fontSize="inherit"
      style={{ marginRight: "0.35rem" }}
    />
  );

  const reduxIcon = (
    <span
      className="iconify"
      data-icon="simple-icons:redux"
      data-inline="false"
      style={{ fontSize: "1.5rem", margin: "0 0.35rem" }}
    />
  );

  const javascriptIcon = (
    <Icon
      className="devicon-javascript-plain"
      fontSize="inherit"
      style={{ margin: "0 0.35rem" }}
    />
  );

  const htmlIcon = (
    <Icon
      className="devicon-html5-plain"
      fontSize="inherit"
      style={{ margin: "0 0.35rem" }}
    />
  );

  const jqIcon = (
    <Icon
      className="devicon-jquery-plain"
      fontSize="inherit"
      style={{ margin: "0 0.35rem" }}
    />
  );
  const cssIcon = (
    <Icon
      className="devicon-css3-plain"
      fontSize="inherit"
      style={{ margin: "0 0.35rem" }}
    />
  );

  const nodeJSIcon = (
    <Icon
      className="devicon-nodejs-plain"
      fontSize="inherit"
      style={{ margin: "0 0.35rem" }}
    />
  );

  const materialUIIcon = (
    <Icon
      className="devicon-materialui-plain"
      fontSize="inherit"
      style={{ margin: "0 0.35rem" }}
    />
  );

  const toDoListIcons = (
    <Box className={classes.icons}>
      {reactIcon}
      {javascriptIcon}
      {htmlIcon}
      {cssIcon}
    </Box>
  );

  const portfolioWebsiteIcons = (
    <Box className={classes.icons}>
      {reactIcon}
      {nodeJSIcon}
      {javascriptIcon}
      {materialUIIcon}
      {htmlIcon}
      {cssIcon}
    </Box>
  );

  const sdIcons = (
    <Box className={classes.icons}>
      {nextjsIcon}
      {expressJsIcon}
      {tailwindcssIcon}
      {reactIcon}
      {javascriptIcon}
      {materialUIIcon}
      {htmlIcon}
      {cssIcon}
    </Box>
  );

  const mlandIcons = (
    <Box className={classes.icons}>
      {expressJsIcon}
      {bootStrapIcon}
      {reactIcon}
      {javascriptIcon}

      {htmlIcon}
      {cssIcon}
    </Box>
  );

  const qhIcons = (
    <Box className={classes.icons}>
      {nextjsIcon}
      {expressJsIcon}
      {mongoIcon}
      {reactIcon}
      {javascriptIcon}
      {materialUIIcon}
      {htmlIcon}
      {cssIcon}
    </Box>
  );

  const calculatorIcons = (
    <Box className={classes.icons}>
      {javascriptIcon}
      {htmlIcon}
      {cssIcon}
      {bootStrapIcon}
      {jqIcon}
    </Box>
  );

  const cssArtIcons = (
    <Box className={classes.icons}>
      <Icon
        className="devicon-html5-plain"
        fontSize="inherit"
        style={{ marginRight: "0.35rem" }}
      />
      {cssIcon}
    </Box>
  );

  return (
    <Box className={`${classes.columnDiv} ${classes.mainDiv}`} id="Projects">
      <Typography className={`${classes.projectText} ${classes.headerText}`}>
        Projects
      </Typography>
      <Divider className={`${classes.divider} ${classes.projectsDivider}`} />
      <Project
        title="Portfolio Website"
        icons={portfolioWebsiteIcons}
        description="This portfolio website, created to display my projects and skills as well as other information about me."
        image={portfolioWebsiteScreenshot}
        imageTitle="Portfolio website screenshot"
        projectLink="https://kishoreshiraguppi.github.io/portfolio-website/"
        githubLink="https://github.com/kishoreshiraguppi/portfolio-website"
      />

      <Project
        title="SocialDrink"
        icons={sdIcons}
        description="SocialDrink is a social media management solution for businesses."
        image={sdfp}
        imageTitle="SocialDrink screenshot"
        projectLink="https://kishoreshiraguppi.github.io/portfolio-website/"
        githubLink="https://github.com/kishoreshiraguppi/portfolio-website"
      />

<Project
        title="SmartTrades"
        icons={qhIcons}
        description="Smart Trades is a trading dashboard"
        image={strades}
        imageTitle="SmartTrades screenshot"
        projectLink="https://kishoreshiraguppi.github.io/portfolio-website/"
        githubLink="https://github.com/kishoreshiraguppi/portfolio-website"
      />

      <Project
        title="SmartMoney"
        icons={qhIcons}
        description="Smart Money is a personal finance solution for individuals"
        image={smoney}
        imageTitle="SmartMoney screenshot"
        projectLink="https://kishoreshiraguppi.github.io/portfolio-website/"
        githubLink="https://github.com/kishoreshiraguppi/portfolio-website"
      />

      <Project
        title="QueueHero"
        icons={qhIcons}
        description="QueueHero is a wailist management solution for local businesses."
        image={qhfp}
        imageTitle="QueueHero screenshot"
        projectLink="https://kishoreshiraguppi.github.io/portfolio-website/"
        githubLink="https://github.com/kishoreshiraguppi/portfolio-website"
      />

      <Project
        title="Movieland"
        icons={mlandIcons}
        description="A portal to discover the latest movies available"
        image={mlfp}
        imageTitle="Movieland screenshot"
        projectLink="https://kishoreshiraguppi.github.io/portfolio-website/"
        githubLink="https://github.com/kishoreshiraguppi/portfolio-website"
      />

      <Project
        title="Venkateshwara Temple Website"
        icons={calculatorIcons}
        description="This is a project done to provide information about this temple place."
        image={kvk}
        imageTitle="Temple site screenshot"
        projectLink="https://github.com/kishoregs/catch-me-if-you-can"
        githubLink="https://github.com/kishoregs/catch-me-if-you-can"
      />

      <Project
        title="Hayagreeva"
        icons={qhIcons}
        description="Hayagreeva is a coaching institute for higher studies."
        image={hayag}
        imageTitle="Hayagreeva screenshot"
        projectLink="https://kishoreshiraguppi.github.io/portfolio-website/"
        githubLink="https://github.com/kishoreshiraguppi/portfolio-website"
      />

      <Project
        title="To-Do List"
        icons={toDoListIcons}
        description="A to-do list application made with Reactjs and Redux. Features include the ability to sort tasks, a fully responsive design, and a dark mode and a pink mode."
        image={toDoListScreenshot}
        imageTitle="To-do List screenshot"
        projectLink="https://kishoreshiraguppi.github.io/react-to-do-list/"
        githubLink="https://github.com/kishoreshiraguppi/react-to-do-list"
      />

      <Project
        title="Game : Catch-Me-If-You-Can"
        icons={calculatorIcons}
        description="A simple game made with JS."
        image={CMIC}
        imageTitle="Game screenshot"
        projectLink="https://github.com/kishoregs/catch-me-if-you-can"
        githubLink="https://github.com/kishoregs/catch-me-if-you-can"
      />

      {/* <Project
        title="CSS Art"
        icons={cssArtIcons}
        description="A collection of drawings made with pure CSS and HTML."
        image={cssArtScreenshot}
        imageTitle="Screenshot of a CSS art drawing of Hello Kitty."
        projectLink="https://codepen.io/collection/nJwkWd"
        githubLink="https://github.com/kishoreshiraguppi/css-art"
      /> */}
    </Box>
  );
};

export default ProjectsPage;
